import { FieldType, CMS_FIELD_PLUGIN_ID } from '@wix/wix-data-schema-types'
import {
  string,
  optional,
  boolean,
  objectProperties,
  list,
  object,
} from './utils/validate'

const genericFieldTypeConfigSchema = {
  type: optional(string),
  displayName: optional(string),
  pluginId: optional(string),
  plugin: optional(string),
  queryOperators: optional(list(string)),
  systemField: optional(boolean),
  sortable: optional(boolean),
  isDeleted: optional(boolean),
  pii: optional(boolean),
  readOnly: optional(boolean),
  description: optional(string),
  plugins: optional(
    objectProperties({
      [CMS_FIELD_PLUGIN_ID]: optional(
        objectProperties({
          internal: optional(boolean),
        }),
      ),
    }),
  ),
}

const pagelinkSchema = {
  linkedRouterPage: string,
  calculator: objectProperties({
    id: optional(string),
    config: objectProperties({
      pattern: string,
      lowercase: optional(boolean),
    }),
  }),
  ...genericFieldTypeConfigSchema,
}

const referenceTypeConfigSchema = {
  referencedCollection: string,
  ...genericFieldTypeConfigSchema,
}

const multiReferenceTypeConfigSchema = {
  referencingFieldKey: string,
  referencingDisplayName: string,
  ...referenceTypeConfigSchema,
}

const arrayTypeConfigSchema = {
  elementType: optional(
    objectProperties({
      type: optional(string),
    }),
  ),
  ...genericFieldTypeConfigSchema,
}

const objectTypeConfigSchema = {
  fields: optional(object),
  ...genericFieldTypeConfigSchema,
}

const slugSchema = {
  pattern: string,
  ...genericFieldTypeConfigSchema,
}

export {
  genericFieldTypeConfigSchema,
  pagelinkSchema,
  referenceTypeConfigSchema,
  multiReferenceTypeConfigSchema,
  arrayTypeConfigSchema,
  objectTypeConfigSchema,
}

export default {
  default: genericFieldTypeConfigSchema,
  [FieldType.pageLink]: pagelinkSchema,
  [FieldType.reference]: referenceTypeConfigSchema,
  [FieldType.multiReference]: multiReferenceTypeConfigSchema,
  [FieldType.array]: arrayTypeConfigSchema,
  [FieldType.object]: objectTypeConfigSchema,
  [FieldType.slug]: slugSchema,
}
